import { merge } from "lodash";

import { KeywordsGroupUtilities } from "app/UtilitiesAndConstants/UtilityFunctions/KeywordsGroupUtilities";
import DefaultDataFetcherFactory from "app/components/widget/widget-fetchers/DefaultDataFetcher";
import type { IDataFetcherFactory } from "app/components/widget/widget-fetchers/IDataFetcher";
import { proNavigator } from "single-spa/react-app/ProNavigator";

class KeywordGroupsDataFetcher implements IDataFetcherFactory<any> {
    create(widget) {
        const timeGranularity =
            widget.apiParams.timeGranularity === "Daily" ? "Weekly" : widget.apiParams.timeGranularity;
        const { keyword } = proNavigator.getParams();
        const defaultFetcherFactory = DefaultDataFetcherFactory;
        const targetFetcher = defaultFetcherFactory.create(widget);
        return {
            ...targetFetcher, // copy any other functions / props that might be added in the future to the default fetcher
            async fetch() {
                const { GroupHash } = await KeywordsGroupUtilities.getGroupByName(keyword);
                // and override the fetch method.
                if (!GroupHash) {
                    return targetFetcher.fetch(
                        merge({}, widget.apiParams, {
                            timeGranularity,
                        }),
                    );
                } else {
                    return targetFetcher.fetch(
                        merge({}, widget.apiParams, {
                            GroupHash,
                            timeGranularity,
                        }),
                    );
                }
            },
        };
    }
}

export default new KeywordGroupsDataFetcher();
